import React from 'react';
import SearchResult from '../../shared/SearchResults';

export default function CsmClosed() {
  return <SearchResult statuses={['CLSD']} pageType="Closed" />;
}
